import React, { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import ColumnResizer from 'react-column-resizer';
import { Spin } from 'antd';
import * as actions from '../../../redux/actions/selectionOfSuppliers';
import TimeClickFileBlue from '../../../assets/images/TimeClockFileBlue.svg';
import style from './SuppliersSearchResult.module.scss';
import Pagination from '../Pagination';
import Modal from '../Modal';
import { ISupplier } from '../../../redux/reducers/selectionOfSuppliers';
import { IState } from '../../../types/interfaces';
import api from '../../../helpers/api';
import useWindowDimensions from '../../../helpers/hooks/useWindowDimensions';
import ServerError from '../Errors/ServerError';
import NotFoundWithMargin from '../Errors/NotFoundWithMargin';

interface IProps {
  data: ISupplier[];
  setSuppliersPage: (payload: number) => void;
  searchId: number;
  setSuppliers: Function;
  lastPage: number;
  page: number;
  errors: string;
}

const SuppliersSearchResult = ({ data, setSuppliersPage, searchId, setSuppliers, lastPage, page, errors }: IProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [active, setActive] = useState(false);
  const [itemIndex, setItemIndex] = useState(0);
  const { width } = useWindowDimensions();

  const handleClick = (index: number) => {
    setActive(!active);
    setItemIndex(index);
  };

  const collumns = [
    { name: '№', resizable: false },
    { name: 'Организация', resizable: true },
    { name: 'ИНН', resizable: true },
    { name: 'КПП', resizable: true },
    { name: 'Регистрация', resizable: true },
    { name: 'ОКПД2', resizable: true },
    { name: 'ОКАТО', resizable: true },
    { name: 'МСП', resizable: true },
    { name: 'РНП', resizable: true },
    { name: 'Участия', resizable: true },
    { name: 'Победы', resizable: true },
  ];

  return (
    <div className={style.wrapper}>
      {errors && <ServerError />}
      {!data?.length && searchId && <NotFoundWithMargin />}
      {data?.length ? (
        <>
          {isLoading ? (
            <div className={style.spin}>
              <Spin />
            </div>
          ) : (
            <div className={style.tableWrapper}>
              <table className={style.table}>
                <thead className={style.tableHeader}>
                  <tr className={style.head}>
                    {collumns.map((coll, index) => (
                      <Fragment key={coll.name}>
                        <th className={style.th}>{coll.name}</th>
                        {collumns[index + 1]?.resizable ? <ColumnResizer className={style.columnResizer} /> : null}
                      </Fragment>
                    ))}
                  </tr>
                </thead>
                {data.map((el, index) => (
                  <tbody className={style.body} key={index.toString()}>
                    <tr className={style.firstRow}>
                      <td className={style.index}>{(page - 1) * 10 + index + 1}</td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td colSpan={21}>
                        <div className={style.group}>
                          <button className={style.name} type="button" onClick={() => handleClick(index)}>
                            {el.name ? el.name : el.short_name}
                          </button>
                          <button
                            type="button"
                            className={`${style.report} ${style.blue}`}
                            onClick={() => {
                              history.push(`/,${el.inn},${el.kpp}`);
                            }}
                          >
                            <img src={TimeClickFileBlue} alt="Скачать" />
                            Экспресс-отчёт
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr className={style.secondRow}>
                      {/* eslint-disable-next-line */}
                      <td />
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.organization}>{el.short_name ? el.short_name : el.name} </p>
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.inn}>{el.inn}</p>
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.kpp}>{el.kpp}</p>
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.etp}>{el.registered_on_etp ? 'Да' : 'Нет'}</p>
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        {el?.okpd2_codes?.map((code: string, idx: number) => (
                          <p className={style.okpd} key={idx.toString()}>
                            {code}
                          </p>
                        ))}
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        {el?.regions?.map((region, idx: number) => (
                          <p className={style.okato} key={idx.toString()}>
                            {region.name}
                          </p>
                        ))}
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.msp}>{el.is_msp ? 'Да' : 'Нет'}</p>
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.rpn}>{el.is_dishonest ? 'Да' : 'Нет'}</p>
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.participation}>
                          {el.relevance_raw_values.procedure_bids_count_total || '-'}
                        </p>
                      </td>
                      {/* eslint-disable-next-line */}
                      <td className={style.td} />
                      <td>
                        <p className={style.participation}>
                          {el.relevance_raw_values.procedure_bids_count_won_total || '-'}
                        </p>
                      </td>
                      {/* eslint-disable-next-line */}
                      {width > 1919 && <td />}
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          )}
          {lastPage >= 0 && (
            <div className={style.pagination}>
              <Pagination
                lastPage={lastPage}
                setPage={setSuppliersPage}
                page={page}
                searchId={searchId}
                inn=""
                setData={async (page1: number) => {
                  setIsLoading(true);
                  await api.getSuppliersData(searchId, page1).then((data1) => {
                    setSuppliers(data1);
                  });
                  setIsLoading(false);
                }}
              />
            </div>
          )}
        </>
      ) : null}
      {active && <Modal active={active} setActive={setActive} itemIndex={itemIndex} />}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  data: state.selectionOfSuppliers.data,
  searchId: state.selectionOfSuppliers.searchId,
  page: state.selectionOfSuppliers.current_page,
  lastPage: state.selectionOfSuppliers.last_page,
  errors: state.selectionOfSuppliers.errors,
});

export default connect(mapStateToProps, actions)(SuppliersSearchResult);
